import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import { Login } from './components/Login';
import { PrivateRoute } from './utils/PrivateRoute';
import Voucher from './components/Voucher';
import PhoneList from './components/PhoneList';
import ShuttleList from './components/ShuttleList';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PassengerList from './components/PassengerList';

class App extends Component {
  render() {

    const history = createBrowserHistory();

    return (
      <Router history={history}>
        <Switch>
          <PrivateRoute exact path="/voucher" component={Voucher} />
          <PrivateRoute exact path="/passengerlist" component={PassengerList} />
          <PrivateRoute exact path="/shuttlelist" component={ShuttleList} />
          <PrivateRoute exact path="/phonelist" component={PhoneList} />
          <Route path="/login" component={Login} />
          <Redirect from="*" to="/voucher" />
        </Switch>
        <ToastContainer />
      </Router>
    );
  }
}

export default App;